module.exports = __webpack_public_path__ + "img/img_news.200bba10.png";